import {
  GET_JOB_ROLE_PREVIEW_DATA,
  SET_PREVIEW_DATA,
  SET_ROUND_DATA,
  UPDATE_ROUND_DATA,
} from './action'
const INITIAL_STATE = {
  roundData: [],
  updateRoundData: [],
  previewData: {},
  jobRolePreviewData: [],
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_ROUND_DATA:
      return {
        ...state,
        roundData: action.data,
      }
    case SET_PREVIEW_DATA:
      return {
        ...state,
        previewData: action.data,
      }
    case UPDATE_ROUND_DATA:
      return {
        ...state,
        updateRoundData: action.data,
      }
    case GET_JOB_ROLE_PREVIEW_DATA:
      return {
        ...state,
        jobRolePreviewData: action.data,
      }
    default:
      return state
  }
}
